import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 10px 18px 0;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
